// Простая навигация между 8 экранами ТЗ раздел 3.3 — минимальная, без дизайн-системы (Этап 5
// сфокусирован на данных/флоу, визуальный полироль — отдельная задача).
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ROUTES = [
  { path: "/", key: "nav_plans" },
  { path: "/subscription", key: "nav_subscription" },
  { path: "/devices", key: "nav_devices" },
  { path: "/change-plan", key: "nav_change_plan" },
  { path: "/payments", key: "nav_payments" },
  { path: "/cancel", key: "nav_cancel" },
  { path: "/promo", key: "nav_promo" },
] as const;

export function NavBar() {
  const { t } = useTranslation();
  return (
    <nav style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", marginBottom: "1rem" }}>
      {ROUTES.map(({ path, key }) => (
        <NavLink key={path} to={path} end={path === "/"}>
          {t(key)}
        </NavLink>
      ))}
    </nav>
  );
}
